import ReportDefinitionItem from "./ReportDefinitionItem";
import BaseReportDefinition from "@/pages/Models/BaseReportDefinition";

export default class ReportDefinition extends BaseReportDefinition {
    public items: ReportDefinitionItem[] = [];
    
    public isReportDefinition: boolean = true;
}